export const ROLE_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Rol guardado exitosamente.",
  DISABLE_SUCCESS: "Rol deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Rol habilitado exitosamente.",
};

export const ROLE_MESSAGES_ERROR = {
  SAVE_ERROR: "Error al guardar el rol. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR: "Error al deshabilitar el rol. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR: "Error al habilitar el rol. Por favor, inténtalo de nuevo.",
};
